import React from "react";

// reactstrap components
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	Row,
	Col
} from "reactstrap";
import moment from 'moment';
import { Link } from "react-router-dom";

// Requests
import { getLetterRequest } from 'api/letter';
// Helpers
import { formatLetterType, formatLetterSubtype } from "helpers/letter";
import { formatLetterStatus } from "helpers/status";
import { formatPrice } from "helpers/pricing";

class LetterDetails extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			letter: null
		}
	}

	async componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
		const id = params.get('id');

		if (id) {
			const letter = await getLetterRequest(id);
			this.setState({ letter })
		} else {
			this.goTo('/letters')
		}
	}

	goTo = path => this.props.history.push(path);

	render() {

		const {
			letter = {}
		} = this.state;

		const {
			_id,
			type,
			subtype,
			status,
			client,
			send_date,
			sent_at,
			sent_by,
			created_at,
			updated_at,
			postal_number,
			scanned_letter,
			payment
		} = letter || {};

		return (
			<>
				<div className="content">
					<Row>
						<Col md="12">
							<Card>
								<CardHeader className="mb-5">
									<CardTitle tag="h3">
										Letter Details
                  					</CardTitle>
									<Button
										className="float-right"
										color="default"
										onClick={() => this.goTo('/letters')}
									>
										Back
                 					</Button>
								</CardHeader>
								<CardBody>
									{!letter
										? <div>Loading...</div>
										: <>
											<div className="typography-line">
												<h4>
													<span>ID</span>
													{_id}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Type</span>
													{type ? formatLetterType(type) : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Subtype</span>
													{type ? formatLetterSubtype(subtype) : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Status</span>
													{status ? formatLetterStatus(status) : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Payment Amount</span>
													<p className="text-success">{payment ? `PHP ${formatPrice(payment.amount)}` : "N/A"}</p>
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Client</span>
													{client ? 
														<Link to={`/client?id=${client._id}`}>
															{`${client.first_name} ${client.last_name}`}
														</Link>
													:
														"N/A"
													}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Send Date</span>
													{send_date ? moment(send_date).format("MM/DD/YYYY") : "N/A"}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Sent At</span>
													{sent_at ? moment(sent_at).format("MM/DD/YYYY") : "N/A"}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Sent By</span>
													{sent_by ? `${sent_by.first_name} ${sent_by.last_name}` : "N/A"}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Postal Receipt Number</span>
													{postal_number || "N/A"}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Scanned Letter</span>
													{scanned_letter 
													? <a  target="_blank" rel="noopener noreferrer" href={scanned_letter}>{scanned_letter}</a>
													: "N/A"}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Created At</span>
													{created_at ? moment(created_at).format("YYYY-MM-DD HH:mm:ss") : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Updated At</span>
													{updated_at ? moment(updated_at).format("YYYY-MM-DD HH:mm:ss") : "N/A"}
												</h4>
											</div>
										</>
									}
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</>
		);
	}
}

export default LetterDetails;
